import React from "react";

import "./home.css"

import PrimarySearchAppBar from "../../Components/NavBar";
import HomeButton from "../../Components/HomeButton";
import Footer from "../../Components/Footer";
import Partners from "../../Components/Partners";

const MobileComponent = () => {

    function handleClick() {
        document.getElementById("about").scrollIntoView({ behavior: "smooth" });
    }


    return (
    <>

    <div style={ { overflowX:"hidden" } }>
        <div className="section-1" id="home">
            <div style={ { padding: "1rem" } }>
                <PrimarySearchAppBar />
            </div>
            <div className="logo">
                <img style={ { width: "80%", maxWidth: "300px", marginTop: "1.5rem" } } src='/m-logo.png' alt="logo"  className="logo" />
                <p style={ { margin: "-1.5rem 10% 10px 10%", fontSize: "20px", opacity: "0.7" } }>
        No need of staking, No need of claiming!
Recieve BNB rewards directly on the wallet where you hold your REWARDScoin.</p>
                <HomeButton text="REWARDScoin Tracker"/>
                <img onClick={ handleClick }  style={ { width: "15%", top: "550px" ,maxWidth: "50px", position: "absolute"} } src="/Vector.png" alt="vector" />
            </div>
            <div>
                
            </div>
        </div>

        <div className="main" style={ { padding: "30px" } }>

        <div id="about">
            <div style={ { padding: "7rem 2% 2rem 2%", fontSize: "1rem", overflow: "hidden" } }>
            <img src="/about us.png" alt="logo" className="about-us-img"/>
            <p >REWARDScoin is the newest and ultimate coin created with the purpose of maximizing the rewards for its holders. 
Based on Binance Smart Chain, REWARDScoin futures multiple rewards mechanisms that are activated by the REWARDScoin Wallets. Rewardscoin holders proportionally will receive the entire 8% BNB rewards from the tax fee applied on transactions. All this whilst the REWARDScoin Deployer will be performing buy-backs and burns making REWARDScoin more rare and of greater value.</p>
            </div>
            <div style={ { display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" } }>
                <img style={ { padding: "0 0 6rem 0", width: "75%", maxWidth: "300px"}} src="/web.gif" alt="logo" className="binance-coin" />
            </div>
        </div>

        <div id="tokenomics">
            <div style={ { fontSize: "1rem",  width: "100%" } }>
                <img  src="/token information.png" alt="logo" className="tokenomics-img" />
                <div>
                <p style={ { marginTop: "1.5rem" }  } >
                    <p><span style={ { fontWeight: "bold" } } >REWARDScoin DEPLOYER: </span> Daily Buy-back and burn.</p>

                    <p><span style={ { fontWeight: "bold" } } >REWARDScoin POOL: </span>Staking the BNB rewards, which will be invested in DeFi partners/projects, paying out a weekly dividend, proportionally to all the holders that hold a minimum amount of 1,000 REWARDScoin in a unique wallet address.</p>

                    <p><span style={ { fontWeight: "bold" } } >REWARDScoin VAULT: </span>Daily BNB rewards, incentives and contests.</p>

                    <p><span style={ { fontWeight: "bold" } } >REWARDScoin TEAM : </span>Development, marketing and rewards.</p>
                </p>
                    <HomeButton text="Earn Rewards"/>
                </div>
            </div>
            <div style={ { display: "flex", justifyContent: "center", margin: "10rem 0 2rem 0" } }>
            <div className="token-info"  style={ { maxWidth: "300px" }  }>
                <img src="/tokenomics.png" alt="logo" className="token-info-img" />
                <div style={ { lineHeight: "14px", marginTop: "40px",  opacity: "0.7", fontSize: "17px" } }>
                <p><span style={ { fontWeight: "bold" } }>Token name:</span> REWARDS COIN</p>
                <p><span style={ { fontWeight: "bold"} }>Token Address:</span><span style={ { marginTop: "15px", fontSize: "13px" } }> 0x434d9BA4A56469c90C0EBd0BE56cd46Dc8cf75d5</span></p>
                <p><span style={ { fontWeight: "bold" } }>Symbol:</span> 1RC</p> 
                <p><span style={ { fontWeight: "bold" } }>Decimals:</span> 18</p> 
                <p><span style={ { fontWeight: "bold" } }>Supply:</span> 100,000,000</p> 
                <p><span style={ { fontWeight: "bold" } }>Tax:</span> 8%</p>
                <p><span style={ { fontWeight: "bold" } }>8% BNB Rewards</span></p>
                <p><span style={ { fontWeight: "bold" } }>Smart Chain:</span> BSC</p>
                </div>
                <div style={ { lineHeight: "10px", margin: "60px 0 0 0" } }>
                <h4 style={ { color: "#D0F1FF"} }>PINKSALE PRESALE</h4> 
                <h4 style={ { color: "#D0F1FF"} }>HARD CAP: 160 BNB</h4> 
                <h4 style={ { color: "#D0F1FF"} }>SOFT CAP: 80 BNB</h4> 
                </div>
                <img style={ { position: "absolute", zIndex: "99", left: "10.5rem", top: "29rem", width: "250px" } } src="/logo.png" alt="logo" />
            </div>
            </div>
        </div>

      <div id="whitepaper" className="whitepaper" style={ {  display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: "5rem" }  }>
        <img  src="/whitepaper.png" alt="whitepaper"  style={  { width: "70%", maxWidth: "400px", margin: "1.5rem 0 1rem 0" } } />
        <a href="https://rewards-coin.gitbook.io/rewardscoin-whitepaper/" target="_blank" rel="noreferrer"><HomeButton text="Download" /></a>
      </div>

      <div id="audit" className="audit" style={ { display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: "4rem 0.75rem 7rem 0.75rem" }  }>
        <img  src="/audit.png" alt="audit"  style={  { width: "35%", maxWidth: "100px", marginBottom: "1.5rem" } } />
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ Doesn't appear to be a honey pot.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ Can't suspend trading.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ No blacklist function.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ You may sell all tokens at once.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ Contract source vode verified.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2", marginBottom: "3rem" } }>✅ No mint function.</p>
        <a href="https://github.com/CFG-NINJA/audits/blob/3b91aca0c5b3430d84e72615dd63e3369b7f2f40/20221222_CFGNINJA_REWARDS%20COIN_Audit.pdf" target="_blank" rel="noreferrer"><HomeButton text="Audit Info" /></a>
      </div>

        <div id="roadmap"  className="roadmap">
            <div style={ { padding: "0rem 5% 2rem 10%", fontSize: "1.5rem"} }>
            <img style={ { width: "100%" } } src="/roadmap text.png" alt="logo" className="roadmap-img"/>
            </div>
            <div className="roadmap-info" style={ { marginLeft: "-3rem"} }>
                <div style={ { display: "flex", justifyContent: "center" } } >
                    <img  style={ { width: "90px" } } src="/m roadmap.png" alt="logo" className="roadmap-info-img" />
                </div>
                <div className="roadmap-text" style={ { top: "10.5rem", left: "6rem", width: "80%" } }>
                    <h3 style={ { color: "#F3BA2F", fontSize: "18px" } }>STAGE 1</h3>
                    <p className="m-text">● Core branding and &nbsp;&nbsp;&nbsp;web development</p>
                    <p className="m-text">● Presale Round</p>
                    <p className="m-text">● Listing on PCS</p>
                    <p className="m-text">● Major burn events</p>
                    <p className="m-text">● Community giveaways &nbsp;&nbsp;&nbsp;and development</p>
                </div>
                <div className="roadmap-text" style={ { top: "28.5rem", left: "-3rem" } }>
                    <h3 style={ { color: "#F3BA2F", fontSize: "18px" } }>STAGE 2</h3>
                    <p>1RC DAPP</p>
                </div>
                <div className="roadmap-text" style={ { top: "33.5rem", left: "5.5rem" } }>
                    <h3 style={ { color: "#F3BA2F", fontSize: "18px" } }>STAGE 3</h3>
                    <p>1RC SWAP</p>
                </div>
                <div className="roadmap-text" style={ { top: "37.5rem", left: "-3rem", width: "80%" } }>
                    <h3 style={ { color: "#F3BA2F", fontSize: "18px" } }>STAGE 4</h3>
                    <p>1RC WALLET</p>
                </div>
                <div className="roadmap-text" style={ { top: "42.5rem", left: "5.5rem", width: "80%" } }>
                    <h3 style={ { color: "#F3BA2F", fontSize: "18px" } }>STAGE 5</h3>
                    <p>1RC MINING NFTS</p>
                </div>
                <div className="roadmap-text" style={ { top: "46.5rem", left: "-3rem" } }>
                    <h3 style={ { color: "#F3BA2F", fontSize: "18px" } }>STAGE 6</h3>
                    <p>TBA</p>
                </div>
            </div>
        </div>
        <Partners />
        <img src="/logo.png" alt="logo" style={ { width: "30%", maxWidth: "400px", minWidth: "200px" } } />
        </div>
        
    </div>

    <Footer />
    
    </>
    );
};

export default MobileComponent;
